import request from '../request';

export const fetchCountries = async () => {
    return await request.get('/data/countries');
};

export const fetchRegions = async (countryCode = '') => {
    const params = { countryCode };
    return await request.get('/data/regions', params);
};

export const fetchDegrees = async (searchString = '') => {
    const params = { major: searchString };
    return await request.get('/v4/majors', params);
};
